import { h } from 'preact';
import clsx from 'clsx';
import ClickSelection from '../../threekit-components/click-selection';
import { useThreekit } from '../../threekit-context';
import Image from '../../../utils/image';
import SwiperNavigation, { swiperNavConfig } from '../swiper-navigation';
import { Swiper, SwiperSlide } from '../swiper';

function HardwareSelector({ products, square }) {
  const { getSelectedVariant, darkMode } = useThreekit();
  const variants = products.reduce((v, p) => [...v, ...p.variants.edges], []);
  const selectedVariant = getSelectedVariant(products);

  const navigation =
    (square && variants.length > 5) || (!square && variants.length > 2);

  const slideStyle = square
    ? 'max-w-[76px] laptop:max-w-[118px]'
    : 'max-w-[171px] laptop:max-w-[287px]';

  return (
    <div className="laptop:py-3 laptop:px-2.5 pl-2.5 py-2.5 m-auto flex">
      <Swiper
        navigation={navigation ? swiperNavConfig : false}
        freeMode={true}
        spaceBetween={10}
        slidesOffsetAfter={square ? 0 : 80}
        slidesPerView={'auto'}
        scrollable
        breakpoints={{
          1024: {
            spaceBetween: 18,
            slidesOffsetAfter: 0,
          },
        }}
        className="h-[100px] laptop:h-36"
      >
        {variants.map((variant) => {
          const variantColor = variant.node.image.alt
            ? variant.node.image.alt.toLowerCase()
            : variant.node.title.toLowerCase();

          return (
            variant.node.configurationEnabled && (
              <SwiperSlide
                key={`hardware-${variant.node.id}`}
                className={slideStyle}
              >
                <ClickSelection
                  element="button"
                  variant={variant}
                  className={clsx(
                    `h-[76px] laptop:h-[118px] laptop:w-auto border-black border-opacity-20 border-2 relative`,
                    {
                      'border-white border-opacity-100':
                        selectedVariant === variant && darkMode,
                      'border-black border-opacity-100':
                        selectedVariant === variant && !darkMode,
                    },
                  )}
                >
                  <Image
                    {...variant.node.image}
                    width={287}
                    height={116}
                    className="h-full"
                    alt={variantColor}
                    title={variantColor}
                  />
                  <p
                    className={clsx(
                      'absolute left-1/2 -translate-x-1/2 whitespace-nowrap mt-2 capitalize font-m-12',
                      {
                        invisible: !(selectedVariant === variant),
                        'text-white': selectedVariant === variant && darkMode,
                        'text-black': selectedVariant === variant && !darkMode,
                      },
                    )}
                  >
                    {variantColor}
                  </p>
                </ClickSelection>
              </SwiperSlide>
            )
          );
        })}
      </Swiper>
      {navigation && (
        <SwiperNavigation className="top-6 laptop:translate-y-[-50%] laptop:top-[50%]" />
      )}
    </div>
  );
}

export default HardwareSelector;
